import { getNestedProperty } from '@opallabs/lambda'
import { PhaseCollection, State, StateKeys } from '../../../../types'

type GetPhases = (state: State) => PhaseCollection | undefined

export const getPhases: GetPhases = (state) =>
  getNestedProperty<PhaseCollection>(
    state,
    StateKeys.jsonApiEntities,
    StateKeys.phase
  )
